var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplayMediumCustomRibbon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h50v50H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.001 3.333c-7.076 0-12.833 5.67-12.833 12.64 0 6.969 5.757 12.638 12.833 12.638 7.077 0 12.834-5.67 12.834-12.639 0-6.97-5.757-12.639-12.834-12.639zm6.943 12.2-2.495 2.52.592 3.57a1.345 1.345 0 0 1-.566 1.326 1.392 1.392 0 0 1-1.456.076l-3.018-1.642-3.017 1.643a1.39 1.39 0 0 1-1.458-.077c-.43-.3-.649-.814-.566-1.325l.592-3.572-2.494-2.519a1.338 1.338 0 0 1-.319-1.375c.164-.482.585-.83 1.097-.909l3.393-.51 1.53-3.209c.45-.952 2.036-.952 2.487 0l1.53 3.208 3.393.511c.51.076.933.427 1.096.909.163.48.039 1.013-.32 1.375z",
    fill: "#1E2969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.928 26.77 6.833 39.317c-.239.433-.22.975.055 1.39a1.35 1.35 0 0 0 1.265.614l5.646-.415 2.494 5.001c.238.452.697.74 1.192.759h.036c.495 0 .972-.271 1.21-.686l4.62-8.09-4.491-7.817a15.702 15.702 0 0 1-4.932-3.305zM43.152 39.318l-7.15-12.476a15.544 15.544 0 0 1-8.8 4.315c-.716.108-1.449.162-2.2.162-.807 0-1.596-.054-2.366-.18l2.292 3.99 6.215 10.852c.239.415.697.686 1.192.686h.037a1.42 1.42 0 0 0 1.21-.759l2.511-5.001 5.757.433c.513.036.99-.198 1.265-.632.275-.415.293-.957.037-1.39z",
    fill: "#1B7690"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplayMediumCustomRibbon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-medium-custom-ribbon.13e15e5122c2ab9c149479b4e6686469.svg";